<template>
  <div>
    <!-- Table -->
    <div class="has-background-white pa-md rounded-lg">
      <b-table
        :data="connection.shipping_accounts"
        :mobile-cards="false"
        :loading="loading"
        hoverable
        class="rounded-lg is-size-7">
        <template>
          <b-table-column
            label="Carrier"
            cell-class="nowrap"
            width="128"
            v-slot="props">
            {{ props.row.carrier.name }}
          </b-table-column>
          <b-table-column
            label="Account Name"
            cell-class="nowrap"
            width="200"
            v-slot="props">
            {{ props.row.nickname }}
          </b-table-column>
          <b-table-column
            label="Owner"
            cell-class="nowrap"
            v-slot="props">
            {{ props.row.owner.name }}
          </b-table-column>
          <b-table-column
            label="Service Levels"
            cell-class="nowrap"
            v-slot="props">
            <p v-for="method in props.row.shipping_methods" :key="method.id">{{ method.name }}</p>
          </b-table-column>
        </template>
        <template #empty>
          <div class="py-xxl has-text-grey has-text-centered">
            {{ loading ? "Loading data..." : "No carrier accounts found!" }}
          </div>
        </template>
      </b-table>
    </div>
    <!-- Update Shipping Methods Modal -->
    <b-modal
      v-if="showUpdateShippingMethodsModal"
      has-modal-card
      :active.sync="showUpdateShippingMethodsModal"
      :can-cancel="['escape', 'x']"
    ><UpdateShippingMethodsModal :connection="connection" @saved:methods="$emit('updated')" /></b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UpdateShippingMethodsModal from '@/components/Models/Connection/Modals/UpdateShippingMethodsModal'

export default {
  components: {
    UpdateShippingMethodsModal
  },
  computed: {
    ...mapGetters(['context'])
  },
  data () {
    return {
      showUpdateShippingMethodsModal: false
    }
  },
  methods: {
    openModal () {
      this.showUpdateShippingMethodsModal = true
    }
  },
  props: ['connection', 'loading']
}
</script>
